import WizardContainer from "./BusinessListingWizard";
import { useLocation } from "react-router-dom";

function BusinessListingWizardAccount() {
    const location = useLocation();
    const { subscriptionId } = location?.state || {};
    return <WizardContainer step={3} subscriptionId={subscriptionId}/>;
}

export default BusinessListingWizardAccount;
